import DIV from '../../DOM/div/DIV.js';
import EL from '../../EL/EL.js';
import NAVFOOTER, { navfooter } from '../../DOM/nav/navbar/navfooter/NAVFOOTER.js';
import { makeStruct } from '../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../enums/ModelData.js';
// Model Structure
export const siteFooterAttr = makeAttrStruct([
    ['class'],
    ['name']
]);
export const siteFooterData = makeDataStruct();
export const siteFooterModel = makeStruct([
    ['attributes', siteFooterAttr],
    ['data', siteFooterData]
]);
// Simplified Model
export function sitefooter(className, name) {
    return {
        attributes: siteFooterAttr(className, name),
        data: siteFooterData()
    };
}
/** A Site Navigation Element */
export default class SITEFOOTER extends DIV {
    footer;
    /** A Site Navigation Element */
    constructor(node, model) {
        super(node, model);
        this.addClass('site-footer');
        this.footer = new NAVFOOTER(this, navfooter());
    }
}
export { EL };
